import useOnClickToTopLogic from "~/components/button-scroll-to-top/button-scroll-to-top.hook";
import useScrollToTopButton2Logic from "./button-scroll-to-top-skin-2.hook";
import styles from "./button-scroll-to-top-skin-2.module.css";

const ScrollToTopSkin2 = () => {
  const { scrollBahevior } = useScrollToTopButton2Logic();
  const { handlerBackToTop, alignButtonStyles } = useOnClickToTopLogic();

  return (
    <>
      {scrollBahevior &&
      <div
        className={styles.buttonScrollToTopSkin2Container}
        role='scroll-to-top-skin2'
        onClick={handlerBackToTop}
        style={alignButtonStyles}>

          <canvas role='img' id='canva-line' width='46' height='46'></canvas>
          <button className={styles.btnBox}>
            <div className={styles.scrollBtnBox}>
              <span className='icon-arrow-top'></span>
            </div>
          </button>
        </div>}

    </>);

};

export default ScrollToTopSkin2;